export const TOKEN_KEY = 'FAST_TOKEN'
export const TIMEOUT_KEY = 'FAST_TIMEOUT'
export const LOGOUT_KEY = 'FAST_WEB_APP_LOGOUT'
// export const LOGOUT_TIMEOUT =  10 * 60 * 1000 // 10 minutes
export const LOGOUT_TIMEOUT = 14 * 24 * 60 * 60 * 1000 // 2 weeks
export const SPECIALIZATION = ['Paediatrics', '  Psychiatric', 'Dental']
export const TITLE = ['Mr', 'Mrs', 'Ms']
export const GENDER = ['male', 'female']
export const CATEGORY = ['adult', 'paediatric']
export const MARITAL_STATUS = ['single', 'married', 'divorced', 'widowed']
export const BLOOD_GROUP = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']
export const GENOTYPE = ['AA', 'AS', 'AC', 'SS', 'SC', 'CC']
export const RHESUS_FACTOR = ['positive', 'negative']
export const EMPLOYMENT_TYPES = ['fulltime', 'partime']
export const EMPLOYMENT_STATUS = ['employed', 'unemployed']
export const WARD_TYPES = <const>['adult male', 'adult female', 'children male', 'children female']
export const WARD_CATEGORIES = <const>['regular', 'vip', 'exclusive']
export const CHARGE_FREQUENCY = <const>['daily', 'weekly', 'monthly']
export const RELIGION = ['christian', 'islam', 'traditional', 'others']
export const SCHEDULE_TYPES = <const>['surgery', 'injections', 'follow-up', 'therapy', 'other']
export type WardType = typeof WARD_TYPES[number]
export type WardCategoryType = typeof WARD_CATEGORIES[number]
export const REDIRECT_KEY = 'FAST_REDIRECT'
export const ONBOARD_KEY = 'FAST_ONBOARDED'
export const BALANCE_VISIBLE_KEY = 'FAST_BALANCE_VISIBLE'
export const ENABLE_CLINIC = import.meta.env.VITE_ENABLE_CLINIC?.toString() === 'true'
export const USSD_SUPPORTTED_BANKS = [
  {
    icon: 'https://nigerianbanks.xyz/logo/guaranty-trust-bank.png',
    name: 'GTB Bank',
    ussd: '737',
  },
  {
    icon: 'https://nigerianbanks.xyz/logo/sterling-bank.png',
    name: 'Sterling Bank',
    ussd: '822',
  },
  {
    icon: 'https://nigerianbanks.xyz/logo/zenith-bank.png',
    name: 'Zenith Bank',
    ussd: '966',
  },
  {
    icon: 'https://nigerianbanks.xyz/logo/united-bank-for-africa.png',
    name: 'United Bank of Africa',
    ussd: '919',
  },
]

export const PROVIDERS = [
  {
    name: 'Clinics',
    to: 'clinics',
  },
  {
    name: 'Pharmacies',
    to: 'pharmacies',
  },
  {
    name: 'Find Providers',
    to: 'other-providers',
  },
] as const
export const ITEMS_PER_PAGE = 5
export const ADDRESS_KEY = 'FAST_ADDRESS'
export const ORDER_FLOW_KEY = 'ORDER_FLOW_DATA'
export const MAP_LOADED_KEY = 'MAP_LOADED'
export const APP_VERSION = '1.6.3'
export const ERROR_MESSAGES = {
  400: "The request couldn't be processed due to invalid input. Please check your data and try again.",
  // 401: 'You need to log in to access this resource. Please log in and try again.',
  // 403: "You don't have permission to access this resource. Please contact support if you believe this is a mistake.",
  404: 'The page or resource you’re looking for couldn’t be found. Please check the URL or return to the homepage.',
  405: 'This action is not allowed. Please contact support if you need assistance.',
  // 409: 'There was a conflict with your request. Please refresh the page or try again later.',
  410: 'The resource you’re looking for has been removed. Please contact support for more information.',
  413: 'The file you are trying to upload is too large. Please reduce the file size and try again.',
  429: 'You’ve made too many requests in a short period. Please wait a moment and try again.',

  // 500-series errors
  500: 'Something went wrong on our end. Please try again later or contact support if the issue persists.',
  501: "This feature isn't available yet. Check back later or contact support for more details.",
  502: "We're having trouble connecting to our service. Please try again in a few minutes.",
  503: 'Our servers are a bit busy right now. Please try again later.',
  504: 'The request is taking too long to process. Please check your connection and try again.',
  505: 'Your browser or app maybe outdated. Try updating to the latest version.',
  506: "There's a small technical issue on our end. Please refresh and try again.",
  507: "We're running low on storage space. Try again later or contact support if the issue persists.",
  508: "It looks like we're stuck in a loop. Please refresh and try again.",
  510: "This request requires extra features that aren't available right now. Try again later.",
  511: 'You need to log in to access this page. Please sign in and try again.',
}
export const SECURE_STORAGE_KEY = 'FAST_SECURE_KEY'
export const USE_BIOMETRICS_KEY = 'FAST_USE_BIOMETRIC_KEY'
export const FIRST_VISIT_KEY = 'FAST_FIRST_VISIT_KEY'
export const REQUEST_APPOINTMENT_KEY = 'REQUEST_APPOINTMENT'
export const REQUEST_APPOINTMENT_SIGNUP_KEY = 'REQUEST_APPOINTMENT_SIGNUP'
export const WEBSITE_SELECTED_PRODUCTS = 'WEBSITE_SELECTED_PRODUCTS'
export const HAS_PREVIOUSLY_LOGGEDIN = 'HAS_PREVIOUSLY_LOGGEDIN'
